import { ConversationParticipantEntity, ConversationParticipantOption } from '@provision/conversation-types';
import { PlatformUser } from '@provision/entity-types';
import { getFullName } from '@provision/formatting-utils';
import { isClientDeleted } from 'src/graphql/entities/client/client.utils';
import { CONVERSATION_ASSIGNEE_NOT_DEFINED_STR } from 'src/graphql/entities/custom-view';
import { appendDisabledUserTextToName } from 'src/graphql/entities/platform-user/utils';
import { ConversationParticipantRaw } from 'src/types';

export function getRequesterFullName(
  requesterData: ConversationParticipantOption | null,
  requester: ConversationParticipantRaw,
): string {
  const requesterFullName = getFullName(requesterData);

  if (!requesterFullName) {
    return CONVERSATION_ASSIGNEE_NOT_DEFINED_STR;
  }

  if (requesterData?.participantEntity === ConversationParticipantEntity.PlatformUser) {
    return requester?.platformUser?.isActive
      ? requesterFullName
      : appendDisabledUserTextToName(requesterFullName);
  }

  if (requesterData?.participantEntity === ConversationParticipantEntity.Client && isClientDeleted(requester?.client)) {
    return `${requesterFullName} (Deleted)`;
  }

  return requesterFullName;
}

export const getRequesterDisplayName = (requesterFullName?: string): string | undefined =>
  requesterFullName && requesterFullName !== CONVERSATION_ASSIGNEE_NOT_DEFINED_STR
    ? requesterFullName
    : undefined;

export function getAssigneeFullName(
  assignee?: PlatformUser | null,
  activeUserIds?: string[],
): string | undefined {
  if (!assignee) {
    return '';
  }

  const assigneeFullNameFullName = getFullName(assignee);
  if (!assigneeFullNameFullName) {
    return;
  }
  return getDisplayUserName(assignee.id, assigneeFullNameFullName, activeUserIds);
}

function getDisplayUserName(
  userId: string,
  userName: string,
  activeUserIds?: string[],
): string {
  return !activeUserIds || activeUserIds.includes(userId)
    ? userName
    : appendDisabledUserTextToName(userName);
}
